// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AdministrativeSupportRouteImport } from './routes/administrative-support'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CoachingAndTrainingRouteImport } from './routes/coaching-and-training'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as GrowthAndTeamBuildingRouteImport } from './routes/growth-and-team-building'
import { Route as KcnJoinOurTeamRouteImport } from './routes/kcn-join-our-team'
import { Route as KcnWorldwideRouteImport } from './routes/kcn-worldwide'
import { Route as KristanRouteImport } from './routes/kristan'
import { Route as MarketingContentAndStrategyRouteImport } from './routes/marketing-content-and-strategy'
import { Route as MeetTheTeamRouteImport } from './routes/meet-the-team'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as RoundTableRouteImport } from './routes/round-table'
import { Route as SalesLeadsAndReferralsRouteImport } from './routes/sales-leads-and-referrals'
import { Route as StrategyCallRouteImport } from './routes/strategy-call'
import { Route as TechnologyAndToolsRouteImport } from './routes/technology-and-tools'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as TheColeMethodRouteImport } from './routes/the-cole-method'
import { Route as ValueRouteImport } from './routes/value'
import { Route as VisibilityAuditRouteImport } from './routes/visibility-audit'
import { Route as WhyJoinKcnRouteImport } from './routes/why-join-kcn'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin.analytics'
import { Route as AuthenticatedAdminAuditsRouteImport } from './routes/_authenticated/admin.audits'
import { Route as AuthenticatedAdminCampaignsRouteImport } from './routes/_authenticated/admin.campaigns'
import { Route as AuthenticatedAdminGrowthPlanRouteImport } from './routes/_authenticated/admin.growth-plan'
import { Route as AuthenticatedAdminImportRouteImport } from './routes/_authenticated/admin.import'
import { Route as AuthenticatedAdminNewRouteImport } from './routes/_authenticated/admin.new'
import { Route as AuthenticatedAdminSeoRouteImport } from './routes/_authenticated/admin.seo'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminTranscriptRouteImport } from './routes/_authenticated/admin.transcript'
import { Route as AuthenticatedAdminEditIdRouteImport } from './routes/_authenticated/admin.edit.$id'
import { Route as AuthenticatedAdminGrowthPlanIndexRouteImport } from './routes/_authenticated/admin.growth-plan.index'
import { Route as AuthenticatedAdminGrowthPlanRecordsRouteImport } from './routes/_authenticated/admin.growth-plan.records'
import { Route as AuthenticatedAdminGrowthPlanSettingsRouteImport } from './routes/_authenticated/admin.growth-plan.settings'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AdministrativeSupportRoute = AdministrativeSupportRouteImport.update({
            id: '/administrative-support',path: '/administrative-support',getParentRoute: () => rootRouteImport
          })
const AgentsRoute = AgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CoachingAndTrainingRoute = CoachingAndTrainingRouteImport.update({
            id: '/coaching-and-training',path: '/coaching-and-training',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const GrowthAndTeamBuildingRoute = GrowthAndTeamBuildingRouteImport.update({
            id: '/growth-and-team-building',path: '/growth-and-team-building',getParentRoute: () => rootRouteImport
          })
const KcnJoinOurTeamRoute = KcnJoinOurTeamRouteImport.update({
            id: '/kcn-join-our-team',path: '/kcn-join-our-team',getParentRoute: () => rootRouteImport
          })
const KcnWorldwideRoute = KcnWorldwideRouteImport.update({
            id: '/kcn-worldwide',path: '/kcn-worldwide',getParentRoute: () => rootRouteImport
          })
const KristanRoute = KristanRouteImport.update({
            id: '/kristan',path: '/kristan',getParentRoute: () => rootRouteImport
          })
const MarketingContentAndStrategyRoute = MarketingContentAndStrategyRouteImport.update({
            id: '/marketing-content-and-strategy',path: '/marketing-content-and-strategy',getParentRoute: () => rootRouteImport
          })
const MeetTheTeamRoute = MeetTheTeamRouteImport.update({
            id: '/meet-the-team',path: '/meet-the-team',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const ResultsRoute = ResultsRouteImport.update({
            id: '/results',path: '/results',getParentRoute: () => rootRouteImport
          })
const RoundTableRoute = RoundTableRouteImport.update({
            id: '/round-table',path: '/round-table',getParentRoute: () => rootRouteImport
          })
const SalesLeadsAndReferralsRoute = SalesLeadsAndReferralsRouteImport.update({
            id: '/sales-leads-and-referrals',path: '/sales-leads-and-referrals',getParentRoute: () => rootRouteImport
          })
const StrategyCallRoute = StrategyCallRouteImport.update({
            id: '/strategy-call',path: '/strategy-call',getParentRoute: () => rootRouteImport
          })
const TechnologyAndToolsRoute = TechnologyAndToolsRouteImport.update({
            id: '/technology-and-tools',path: '/technology-and-tools',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TestimonialsRoute = TestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => rootRouteImport
          })
const TheColeMethodRoute = TheColeMethodRouteImport.update({
            id: '/the-cole-method',path: '/the-cole-method',getParentRoute: () => rootRouteImport
          })
const ValueRoute = ValueRouteImport.update({
            id: '/value',path: '/value',getParentRoute: () => rootRouteImport
          })
const VisibilityAuditRoute = VisibilityAuditRouteImport.update({
            id: '/visibility-audit',path: '/visibility-audit',getParentRoute: () => rootRouteImport
          })
const WhyJoinKcnRoute = WhyJoinKcnRouteImport.update({
            id: '/why-join-kcn',path: '/why-join-kcn',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAnalyticsRoute = AuthenticatedAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuditsRoute = AuthenticatedAdminAuditsRouteImport.update({
            id: '/audits',path: '/audits',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCampaignsRoute = AuthenticatedAdminCampaignsRouteImport.update({
            id: '/campaigns',path: '/campaigns',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminGrowthPlanRoute = AuthenticatedAdminGrowthPlanRouteImport.update({
            id: '/growth-plan',path: '/growth-plan',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminImportRoute = AuthenticatedAdminImportRouteImport.update({
            id: '/import',path: '/import',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNewRoute = AuthenticatedAdminNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSeoRoute = AuthenticatedAdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTranscriptRoute = AuthenticatedAdminTranscriptRouteImport.update({
            id: '/transcript',path: '/transcript',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEditIdRoute = AuthenticatedAdminEditIdRouteImport.update({
            id: '/edit/$id',path: '/edit/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminGrowthPlanIndexRoute = AuthenticatedAdminGrowthPlanIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminGrowthPlanRoute
          })
const AuthenticatedAdminGrowthPlanRecordsRoute = AuthenticatedAdminGrowthPlanRecordsRouteImport.update({
            id: '/records',path: '/records',getParentRoute: () => AuthenticatedAdminGrowthPlanRoute
          })
const AuthenticatedAdminGrowthPlanSettingsRoute = AuthenticatedAdminGrowthPlanSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminGrowthPlanRoute
          })





const AuthenticatedAdminGrowthPlanRouteChildren = {
  AuthenticatedAdminGrowthPlanRecordsRoute: AuthenticatedAdminGrowthPlanRecordsRoute,AuthenticatedAdminGrowthPlanSettingsRoute: AuthenticatedAdminGrowthPlanSettingsRoute,AuthenticatedAdminGrowthPlanIndexRoute: AuthenticatedAdminGrowthPlanIndexRoute
}

const AuthenticatedAdminGrowthPlanRouteWithChildren = AuthenticatedAdminGrowthPlanRoute._addFileChildren(AuthenticatedAdminGrowthPlanRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,AuthenticatedAdminAuditsRoute: AuthenticatedAdminAuditsRoute,AuthenticatedAdminCampaignsRoute: AuthenticatedAdminCampaignsRoute,AuthenticatedAdminGrowthPlanRoute: AuthenticatedAdminGrowthPlanRouteWithChildren,AuthenticatedAdminImportRoute: AuthenticatedAdminImportRoute,AuthenticatedAdminNewRoute: AuthenticatedAdminNewRoute,AuthenticatedAdminSeoRoute: AuthenticatedAdminSeoRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminTranscriptRoute: AuthenticatedAdminTranscriptRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminEditIdRoute: AuthenticatedAdminEditIdRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,SplatRoute: SplatRoute,AdministrativeSupportRoute: AdministrativeSupportRoute,AgentsRoute: AgentsRoute,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,CoachingAndTrainingRoute: CoachingAndTrainingRoute,ContactUsRoute: ContactUsRoute,GrowthAndTeamBuildingRoute: GrowthAndTeamBuildingRoute,KcnJoinOurTeamRoute: KcnJoinOurTeamRoute,KcnWorldwideRoute: KcnWorldwideRoute,KristanRoute: KristanRoute,MarketingContentAndStrategyRoute: MarketingContentAndStrategyRoute,MeetTheTeamRoute: MeetTheTeamRoute,PrivacyRoute: PrivacyRoute,ResourcesRoute: ResourcesRoute,ResultsRoute: ResultsRoute,RoundTableRoute: RoundTableRoute,SalesLeadsAndReferralsRoute: SalesLeadsAndReferralsRoute,StrategyCallRoute: StrategyCallRoute,TechnologyAndToolsRoute: TechnologyAndToolsRoute,TermsRoute: TermsRoute,TestimonialsRoute: TestimonialsRoute,TheColeMethodRoute: TheColeMethodRoute,ValueRoute: ValueRoute,VisibilityAuditRoute: VisibilityAuditRoute,WhyJoinKcnRoute: WhyJoinKcnRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)